import React, { useState, useEffect } from "react";
import HubblePageContainer from "./components/HubblePageContainer";
import classes from "./styles/style.module.css";

import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomInput from "../../assets/components/customInput";
import CustomTextArea from "../../assets/components/CustomTextArea";
import CustomCheckBox from "../../assets/components/CustomCheckBox";
// import { IoPersonAddOutline } from "react-icons/io5";

import HubbleButton from "./components/HubbleButton";
import HubbleFileUploader from "./components/HubbleFileUploader";
import CustomSelect from "../../assets/components/CustomSelect";

import { IoPersonAddOutline, IoTrashOutline } from "react-icons/io5";
import Loading from "../../assets/containers/loadingDialog";
import errorHandler from "../../assets/utils/ErrorHandler";
import {
  createHubbleForm,
  getMyUpload,
  updateHubbleForm,
} from "../../assets/services/apiServices";
import toast from "react-hot-toast";

import states from "../../assets/data/provinces.json";
import cities from "../../assets/data/provinces_cities.json";

const Upload = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector(({ user }) => user);
  const { id } = useParams();

  const [agree, setAgree] = useState(false);
  const [group, setGroup] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [gender, setGender] = useState("");
  const [marriageStatus, setMarriageStatus] = useState("");
  const [workPlace, setWorkPlace] = useState("");
  const [userWorkPlace, setUserWorkPlace] = useState("");
  const [education, setEducation] = useState("");
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [postalCode, setPostalCode] = useState("");
  const [address, setAddress] = useState("");
  const [major, setMajor] = useState("");
  const [desc, setDesc] = useState("");
  const [partners, setPartners] = useState([]);
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});

  const filteredCities = selectedProvince
    ? cities.filter((city) => city.provinceId === selectedProvince.provinceId)
    : [];

  useEffect(() => {
    if (id) {
      fetchMyUpload();
    }
  }, [id]);

  const fetchMyUpload = async () => {
    try {
      setIsLoading(true);
      const response = await getMyUpload(id);
      setGender(response.data.personal.gender === "male" ? "مرد" : "زن");
      setMarriageStatus(
        response.data.personal.marriageStatus === "single" ? "مجرد" : "متاهل"
      );
      setWorkPlace(response.data.personal?.workplace);
      setUserWorkPlace(response.data.personal?.ownerJob);
      setEducation(response.data.personal?.education);
      setSelectedProvince(
        states.find(
          (province) => province.provinceName === response.data.personal?.state
        )
      );
      setSelectedCity(
        cities.find((city) => city.cityName === response.data.personal?.city)
      );
      setPostalCode(response.data.personal?.postalcode);
      setAddress(response.data.personal?.address);
      setMajor(response.data?.major);
      setDesc(response.data?.description);
      setGroup(response.data?.groupMode);
      setGroupName(response.data?.groupName);
      setPartners(
        response.data.groupUsers.map((user) => {
          return {
            id: user._id,
            name: user.fullName,
            personnelCode: user.personnelCode,
            nationalCode: user.nationalCode,
          };
        })
      );
      setAgree(true)
      setFile(response.data?.file);
    } catch (err) {
      errorHandler(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (field, value) => {
    switch (field) {
      case "gender":
        setGender(value);
        break;
      case "marriageStatus":
        setMarriageStatus(value);
        break;
      case "workPlace":
        setWorkPlace(value);
        break;
      case "userWorkPlace":
        setUserWorkPlace(value);
        break;
      case "education":
        setEducation(value);
        break;
      case "selectedProvince":
        setSelectedProvince(states.find((p) => p.provinceName === value));
        setSelectedCity(null);
        break;
      case "selectedCity":
        setSelectedCity(filteredCities.find((c) => c.cityName === value));
        break;
      case "postalCode":
        setPostalCode(value);
        break;
      case "address":
        setAddress(value);
        break;
      case "major":
        setMajor(value);
        break;
      case "desc":
        setDesc(value);
        break;
      case "groupName":
        setGroupName(value);
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const addPartner = () => {
    setPartners([
      ...partners,
      { id: Date.now(), name: "", nationalCode: "", personnelCode: "" },
    ]);
  };

  const removePartner = (id) => {
    setPartners(partners.filter((partner) => partner.id !== id));
  };

  const handlePartnerChange = (id, field, value) => {
    setPartners(
      partners.map((partner) =>
        partner.id === id ? { ...partner, [field]: value } : partner
      )
    );
    setErrors((prev) => ({ ...prev, [`${field}-${id}`]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};

    if (!gender) newErrors.gender = "جنسیت را انتخاب کنید.";
    if (!marriageStatus)
      newErrors.marriageStatus = "وضعیت تأهل را انتخاب کنید.";
    if (!workPlace) newErrors.workPlace = "محل کار را انتخاب کنید.";
    if (!userWorkPlace) newErrors.userWorkPlace = "محل کار شما را انتخاب کنید.";
    if (!education) newErrors.education = "تحصیلات را انتخاب کنید.";
    if (!selectedProvince) newErrors.selectedProvince = "استان را انتخاب کنید.";
    if (!selectedCity) newErrors.selectedCity = "شهر را انتخاب کنید.";
    if (!postalCode) newErrors.postalCode = "کد پستی را وارد کنید.";
    if (!address) newErrors.address = "نشانی را وارد کنید.";
    if (!major) newErrors.major = "رشته را انتخاب کنید.";
    if (!desc) newErrors.desc = "توضیحاتی وارد کنید.";
    if (!file) newErrors.file = "لطفاً یک فایل انتخاب کنید.";
    if (!agree) newErrors.agree = "باید آیین‌نامه را قبول کنید.";

    if (group) {
      if (!groupName) newErrors.groupName = "نام گروه را وارد کنید.";
      partners.forEach((partner) => {
        if (!partner.name)
          newErrors[`name-${partner.id}`] = "نام همگروه را وارد کنید.";
        if (!partner.nationalCode)
          newErrors[`nationalCode-${partner.id}`] =
            "کد ملی همگروه را وارد کنید.";
      });
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm() ) {
      toast.error("موارد درخواستی را با دقت تکمیل کنید");
      return;
    }
    setIsLoading(true);
    const data = {
      personal: {
        gender: gender === "مرد" ? "male" : "female",
        marriageStatus: marriageStatus === "متاهل" ? "married" : "single",
        workplace: workPlace,
        ownerJob: userWorkPlace,
        education: education,
        state: selectedProvince.provinceName,
        city: selectedCity.cityName,
        postalcode: postalCode,
        address: address,
      },
      level: "Level1",
      major: major,
      description: desc,
      groupMode: group,
      groupName: groupName,
      groupUsers: partners.map(({ name, personnelCode, nationalCode }) => ({
        fullName: name,
        personnelCode,
        nationalCode,
      })),
      file: file,
    };
    try {
      if (id) {
        await updateHubbleForm(id,data);
        toast.success("با موفقیت ویرایش شد.");
      }else{
        await createHubbleForm(data);
        toast.success("با موفقیت ارسال شد.");
        navigate(`/hubble`, { replace: true });
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <HubblePageContainer>
      <div className="d-flex justify-content-between align-items-center py-2">
        <h4>مرحله اول</h4>
        <div onClick={() => navigate(-1)}>
          <FaArrowLeftLong size={20} />
        </div>
      </div>

      <section className="my-4">
        {currentUser && (
          <>
            <div className="mt-4">
              <CustomInput
                dark
                label="نام و نام خانوادگی"
                value={currentUser.fullName}
                disabled
              />
            </div>
            <div className="mt-4">
              <CustomInput
                dark
                label="کد ملی"
                value={currentUser.nationalCode}
                disabled
              />
            </div>
            <div className="mt-4">
              <CustomInput
                dark
                label="کد پرسنلی"
                value={currentUser.personnelCode}
                disabled
              />
            </div>
          </>
        )}

        <div className="mt-4">
          <CustomSelect
            label="جنسیت"
            handleChange={(value) => handleChange("gender", value)}
            value={gender}
            options={["زن", "مرد"]}
            placeHolder={"جنسیت"}
            dark
          />
          {errors.gender && (
            <div className={classes.error}>{errors.gender}</div>
          )}
        </div>

        <div className="mt-4">
          <CustomSelect
            label="وضعیت تاهل"
            handleChange={(value) => handleChange("marriageStatus", value)}
            value={marriageStatus}
            options={["متاهل", "مجرد"]}
            placeHolder={"وضعیت تاهل"}
            dark
          />
          {errors.marriageStatus && (
            <div className={classes.error}>{errors.marriageStatus}</div>
          )}
        </div>

        <div className="mt-4">
          <CustomSelect
            label="محل کار صاحب کد پرسنلی"
            handleChange={(value) => handleChange("workPlace", value)}
            value={workPlace}
            options={["فولاد مبارکه", "فولاد سبا", "دیگر"]}
            placeHolder={"محل کار صاحب کد پرسنلی"}
            dark
          />
          {errors.workPlace && (
            <div className={classes.error}>{errors.workPlace}</div>
          )}
        </div>

        <div className="mt-4">
          <CustomSelect
            label="شغل شما"
            handleChange={(value) => handleChange("userWorkPlace", value)}
            value={userWorkPlace}
            options={[
              "بازنشسته",
              "آزاد",
              "نظامی",
              "کارمند دولتی",
              "کارمند خصوصی ",
              "خانه دار",
              "دانش آموز",
              "دانشجو",
              "پاره وقت",
            ]}
            placeHolder={"شغل شما"}
            dark
          />
          {errors.userWorkPlace && (
            <div className={classes.error}>{errors.userWorkPlace}</div>
          )}
        </div>

        <div className="mt-4">
          <CustomSelect
            label="تحصیلات"
            handleChange={(value) => handleChange("education", value)}
            value={education}
            options={[
              "دبستان",
              "دبیرستان دوره اول",
              "دبیرستان دوره دوم",
              "دیپلم",
              "فوق دیپلم ",
              "لیسانس",
              "فوق لیسانس ",
              "دکترا",
              "بالاتر از دکترا",
              "حوزوی",
            ]}
            placeHolder={"تحصیلات"}
            dark
          />
          {errors.education && (
            <div className={classes.error}>{errors.education}</div>
          )}
        </div>

        <div className="mt-4">
          <CustomSelect
            label="استان"
            handleChange={(value) => handleChange("selectedProvince", value)}
            value={selectedProvince?.provinceName || ""}
            options={states.map((p) => p.provinceName)}
            placeHolder={"استان"}
            dark
          />
          {errors.selectedProvince && (
            <div className={classes.error}>{errors.selectedProvince}</div>
          )}
        </div>

        <div className="mt-4">
          <CustomSelect
            label="شهر"
            handleChange={(value) => handleChange("selectedCity", value)}
            value={selectedCity?.cityName || ""}
            options={filteredCities.map((c) => c.cityName)}
            placeHolder={"شهر"}
            dark
          />
          {errors.selectedCity && (
            <div className={classes.error}>{errors.selectedCity}</div>
          )}
        </div>

        <div className="mt-4">
          <CustomInput
            dark
            label="نشانی"
            value={address}
            handleChange={(val) => handleChange("address", val)}
            placeholder={"نشانی"}
          />
          {errors.address && (
            <div className={classes.error}>{errors.address}</div>
          )}
        </div>

        <div className="mt-4">
          <CustomInput
            dark
            label="کد پستی"
            value={postalCode}
            handleChange={(val) => handleChange("postalCode", val)}
            placeholder={"کدپستی"}
          />
          {errors.postalCode && (
            <div className={classes.error}>{errors.postalCode}</div>
          )}
        </div>

        <div className="mt-4">
          <CustomSelect
            label="رشته"
            handleChange={(value) => handleChange("major", value)}
            value={major}
            options={[
              "استندآپ کمدی و نمایش",
              "تقلید صدا و دوبله",
              "مجری گری",
              "خوانندگی و هنرهای مرتبط با عرصه موسیقی",
              "شعرخوانی، نقالی، روایتگری، خطابه خوانی",
              "سرود، تواشیح، ابتهال خوانی",
              "خلاقیت‌های علمی",
              "خلاقیت‌های هنری و تجسمی ",
              "خلاقیت‌های سرگرمی، حرکتی و ورزشی",
              "مهارت و خلاقیت های صنعتی",
            ]}
            placeHolder={"رشته"}
            dark
          />
          {errors.major && <div className={classes.error}>{errors.major}</div>}
        </div>

        <div className="mt-4">
          <CustomTextArea
            dark
            label="توضیحاتی درباره اثر شما"
            value={desc}
            handleChange={(val) => handleChange("desc", val)}
            placeholder={"توضیحات"}
          />
          {errors.desc && <div className={classes.error}>{errors.desc}</div>}
        </div>

        <div className="mt-4">
          <CustomCheckBox
            dark
            label="شرکت به صورت گروهی"
            handleChange={setGroup}
            val={group}
          />
        </div>
        {group && (
          <>
            <div className="mt-4">
              <CustomInput
                dark
                label="نام گروه"
                value={groupName}
                handleChange={(val) => handleChange("groupName", val)}
                placeholder={"نام گروه"}
              />
              {errors.groupName && (
                <div className={classes.error}>{errors.groupName}</div>
              )}
            </div>
            {partners.map((partner) => (
              <div key={partner.id}>
                <div className="mt-4">
                  <CustomInput
                    dark
                    label="نام و نام خانوادگی همگروه"
                    value={partner.name}
                    handleChange={(val) =>
                      handlePartnerChange(partner.id, "name", val)
                    }
                    placeholder={"نام و نام خانوادگی همگروه"}
                  />
                  {errors[`name-${partner.id}`] && (
                    <div className={classes.error}>
                      {errors[`name-${partner.id}`]}
                    </div>
                  )}
                </div>
                <div className="mt-4">
                  <CustomInput
                    dark
                    label="کد ملی هم گروه"
                    value={partner.nationalCode}
                    handleChange={(val) =>
                      handlePartnerChange(partner.id, "nationalCode", val)
                    }
                    placeholder={"کد ملی هم گروه"}
                  />
                  {errors[`nationalCode-${partner.id}`] && (
                    <div className={classes.error}>
                      {errors[`nationalCode-${partner.id}`]}
                    </div>
                  )}
                </div>
                <div className="mt-4">
                  <CustomInput
                    dark
                    label="کد پرسنلی هم گروه (اختیاری)"
                    value={partner.personnelCode}
                    handleChange={(val) =>
                      handlePartnerChange(partner.id, "personnelCode", val)
                    }
                    placeholder={"کد پرسنلی هم گروه"}
                  />
                </div>
                <div className="mt-4">
                  <HubbleButton onClick={() => removePartner(partner.id)}>
                    <IoTrashOutline size={20} className="ml-2" />
                    حذف هم گروهی
                  </HubbleButton>
                </div>
              </div>
            ))}
            <div className="mt-4">
              <HubbleButton onClick={addPartner}>
                <IoPersonAddOutline className="ml-2" />
                افزودن هم گروه
              </HubbleButton>
            </div>
          </>
        )}

        {!id && (
          <>
            <div className="mt-4">
              <CustomCheckBox
                dark
                label="آیین‌نامه را خوانده و آن را قبول دارم"
                handleChange={setAgree}
                val={agree}
              />
              {errors.agree && (
                <div className={classes.error}>{errors.agree}</div>
              )}
            </div>

            <HubbleFileUploader
              file={file}
              setFile={(file) => {
                if (file) {
                  setFile(file.name);
                } else {
                  setFile(null);
                }
              }}
            />
            {errors.file && <div className={classes.error}>{errors.file}</div>}
            {isLoading ? (
              <div className="d-flex justify-content-center">
                <Loading dark />
              </div>
            ) : (
              <HubbleButton onClick={handleSubmit} disabled={!agree}>
                ثبت
              </HubbleButton>
            )}
          </>
        )}
        {id && (
          <div className="mt-4">
            {isLoading ? (
              <div className="d-flex justify-content-center">
                <Loading dark />
              </div>
            ) : (
              <HubbleButton onClick={handleSubmit}>ویرایش</HubbleButton>
            )}
          </div>
        )}
      </section>
    </HubblePageContainer>
  );
};

export default Upload;
